const getters = {
  get_center(state) {
      return state.center
  }
}

export default getters